<template>
  <div class="wrapper">
    <div id="map" ref="map"></div>
    <div class="content">
      <div class="setting">
        <div class="data_div">
          <img class="time_logo" src="../../assets/time_logo.png" alt=""/>
          <van-popover v-model="showPopover" trigger="click" placement="top-start">
            <van-datetime-picker
                v-model="currentDatePover"
                type="date"
                title=""
                @confirm="confirm"
                style="width: 6rem"
                @cancel="cancel"
                :formatter="formatter"
                item-height="50px"
                confirm-button-text="确定"
                visible-item-count="3"
                :max-date="maxDate"
            />
            <template #reference>
              <div class="current-date">{{ currentDate }}</div>
            </template>
          </van-popover>
          <i class="el-icon-caret-bottom" style="font-size: 0.4rem"></i>
        </div>
        <div class="select_div">
          <van-popover v-model="showSpeed" trigger="click" placement="top-start">
            <div class="speed-wrapper">
              <div :class="isCurrentSpeed=='slow'?'is-current-speed':'speed1'" @click="changeSpeed('slow','慢速')">
                慢速
              </div>
              <div class="line"></div>
              <div :class="isCurrentSpeed=='fast'?'is-current-speed':'speed2'" @click="changeSpeed('fast','快速')">
                快速
              </div>
            </div>
            <template #reference>
              <div>{{ selectValue }}</div>
            </template>
          </van-popover>
          <i class="el-icon-caret-bottom" style="font-size: 0.4rem"></i>
        </div>
        <div class="bofang_div">
          <div class="line"></div>
          <img :src="mapStatus == 1? require('../../assets/zanting.png'): require('../../assets/bofang.png')"
               @click="pauseAnimation()"
          />
        </div>
      </div>
      <div class="positionInfo" v-if="trajectoryArr.length>0">
        <div class="history" v-for="(item, index) in trajectoryArr" :key="index">
          <p class="title">{{ item.time }}</p>
          <p class="detail">
            {{ item.address }}
          </p>
        </div>
      </div>
      <div class="positionInfo2" v-else>
       <img src="../../assets/wktH5/no-data.png">
        <div>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getHistoryRecord} from "@/api/zqykt";
import moment from "moment";

export default {
  data() {
    return {
      isCurrentSpeed: 'slow',
      showPopover: false,
      showSpeed: false,
      map: "",
      viaMarker: "",
      polyline: "",
      currentDatePover: new Date(),
      maxDate: new Date(),
      currentDate: "",
      guijiArr: [],
      guijiArr1: [120.716586, 31.322227],
      speed: 1000,
      pathSimplifierIns: {},
      mapStatus: 0,
      passedLineLength: 0,
      havePassedLine: [],
      trajectoryArr: [],
      selectValue: "慢速",
      accessToken: "",
      studentId: "",
      imei: "",
      pic: "",
    }
  },
  mounted() {
    this.currentDate = moment().format("YYYY-MM-DD");
    this.initParam();
    this.getData();
  },
  methods: {
    changeSpeed(speed, e) {
      this.isCurrentSpeed = speed;
      this.selectValue = e;
      if (this.mapStatus == 1 || this.mapStatus == 2) {
        //轨迹运行或者暂停状态
        this.viaMarker.stopMove();
        this.mapStatus = 0;
      }
      this.speed = this.selectValue == '快速' ? 5000 : 1000;
      this.showSpeed = false;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      }
      if (type === 'month') {
        return `${val}月`
      }
      if (type === 'day') {
        return `${val}日`
      }
    },
    confirm(e) {
      this.currentDate = moment(e).format("YYYY-MM-DD")
      this.mapStatus = 0;
      this.getData();
      this.showPopover = false
    },
    cancel() {
      this.showPopover = false
    },
    initParam() {
      let urlParam = this.$route.query;
      this.accessToken = urlParam.accessToken;
      this.studentId = urlParam.studentId;
      this.imei = urlParam.imei;
      this.pic = urlParam.pic;
    },
    getData() {
      this.trajectoryArr = [];
      let currentDate = moment(this.currentDate).format("YYYY-MM-DD");
      let arg = {
        Authorization: this.accessToken,
        cardNo: this.imei,
        date: currentDate
      }
      getHistoryRecord(arg).then(res => {
        this.trajectoryArr = res.content;
        this.guijiArr = this.trajectoryArr.map(p => {
          return [p.lng, p.lat]
        })
        this.getMap()
        this.initroad()
      })
    },
    pauseAnimation() {
      //刚开始状态位0  未开始
      if (this.mapStatus == 0) {
        this.viaMarker.moveAlong(this.guijiArr, this.speed);
        this.mapStatus = 1;
      } else if (this.mapStatus == 1) {
        // 状态1是运行中
        this.viaMarker.pauseMove();
        this.mapStatus = 2;
      } else if (this.mapStatus == 2) {
        //状态2是暂停状态
        this.viaMarker.resumeMove();
        this.mapStatus = 1;
      }
    },
    getMap() {
      let that = this;
      //创建地图
      // eslint-disable-next-line no-undef
      this.map = new AMap.Map("map", {
        //mapStyle: 'amap://styles/grey',
        center: this.guijiArr[0],
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        zoomToAccuracy: true,
        zoom: 15,
        scrollWheel: false,
        dragEnable: true, //是否可拖动
        resizeEnable: true,
        rotateEnable: false,
      });
      // eslint-disable-next-line no-undef
      this.viaMarker = new AMap.Marker({
        map: this.map,
        position: this.guijiArr[0],
        // 将一张图片的地址设置为 icon
        // eslint-disable-next-line no-undef
        icon: new AMap.Icon({
          image: this.pic != "" ? this.pic : "https://zhongqiyun-static-1307006238.cos.ap-shanghai.myqcloud.com/childImage4.png",
          // eslint-disable-next-line no-undef
          size: new AMap.Size(40, 40), //图标所处区域大小
          // eslint-disable-next-line no-undef
          imageSize: new AMap.Size(26, 26), //图标大小
        }),
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        // eslint-disable-next-line no-undef
        offset: new AMap.Pixel(-13, -30),
      });
    },

    //初始化轨迹
    initroad() {
      // this.map.setCenter(this.guijiArr[0]);
      // this.viaMarker.setPosition(this.guijiArr[0]);
      //绘制还未经过的路线
      // eslint-disable-next-line no-undef
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.guijiArr,
        showDir: true,
        strokeColor: "#2BC4AC", //线颜色--蓝色
        strokeOpacity: 1,     //线透明度
        strokeWeight: 6, //线宽
        strokeStyle: "solid"  //线样式
      });
      //绘制路过了的轨迹
      // eslint-disable-next-line no-undef
      let passedPolyline = new AMap.Polyline({
        map: this.map,
        strokeColor: "#008B81", //线颜色-绿色
        //path: this.lineArr,
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6, //线宽
        strokeStyle: "solid"  //线样式
      });
      // console.log(this.guijiArr)
      // this.polyline.setPath(this.guijiArr);
      // console.log(this.guijiArr)
      let guijiList = new Array();
      if (this.guijiArr.length > 0) {
        let lastData = ''
        for (let k = 0; k < this.guijiArr.length; k++) {
          if (lastData == '') {
            lastData = this.guijiArr[k].lng + ":" + this.guijiArr[k].lat
            guijiList.push(this.guijiArr[k])
          } else {
            // console.log(lastData+"~~"+this.guijiArr[k].lng+":"+this.guijiArr[k].lat)
            if (lastData === this.guijiArr[k].lng + ":" + this.guijiArr[k].lat) {
              continue
            } else {
              lastData = this.guijiArr[k].lng + ":" + this.guijiArr[k].lat
              guijiList.push(this.guijiArr[k].lng + ":" + this.guijiArr[k].lat)
            }
          }
        }
      }
      this.viaMarker.on("moving", (e) => {
        passedPolyline.setPath(e.passedPath);
        this.passedLineLength = e.passedPath.length;
        this.havePassedLine = e.passedPath;
        if (this.passedLineLength == guijiList.length) {
          let obj = this.havePassedLine[this.passedLineLength - 1];
          if (
              guijiList[guijiList.length - 1].split(":")[0] == obj.lng &&
              guijiList[guijiList.length - 1].split(":")[1] == obj.lat
          ) {
            this.viaMarker.stopMove();
            this.mapStatus = 0;
          }
        }
      });
      this.map.setFitView(); //合适的视口
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .van-picker__cancel {
  color: #222222;
}

/deep/ .van-picker__confirm {
  color: #2AD0B5;
}

/deep/ .amap-copyright {
  display: none !important;
}

/deep/ .amap-logo {
  display: none !important;
}

/deep/ .amap-icon {
  background: url("../../assets/dingweiborder.png") center center no-repeat;
  background-size: 100%;
}

/deep/ .amap-icon img {
  border-radius: 50%;
  position: absolute;
  left: 50% !important;
  top: 40% !important;
  transform: translate(-50%, -50%);
}

.speed-wrapper {
  width: 75px;
  height: 101px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .line {
    width: 60px;
    height: 1px;
    background: #DBDBDB;
  }

  .is-current-speed {
    color: #2AD0B5;
    line-height: 50px;
  }

  .speed1 {
    line-height: 50px;
  }

  .speed2 {
    line-height: 50px;
  }
}

.wrapper {
  width: 100%;
  position: absolute;
  top: 0rem;
  bottom: 0rem;

  #map {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .content {
    width: 94%;
    margin: 0 auto;
  }

  .setting {
    width: calc(100% - 20px);
    height: 1.12rem;
    position: fixed;
    bottom: 0px;
    z-index: 999;
    background-color: #ffffff;
    border-radius: 15px;
    margin: 10px auto 3.2rem auto;
    display: flex;
    align-items: center;

    .data_div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 2;

      .time_logo {
        margin-right: 10px;
      }

      .current-date {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
    }

    .select_div {
      flex: 1;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      text-align: center;


    }

    .bofang_div {
      display: flex;
      flex: 1;
      justify-content: space-around;

      .line {
        height: 30px;
        background: #979797;
        width: 1px;
      }

      img {
        width: 30px;
        height: 30px;
      }
    }
  }
.positionInfo2{
  width: calc(100% - 20px);
  height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  bottom: 10px;
  z-index: 999;
  background-color: #ffffff;
  border-radius: 15px;
  margin: 10px auto 0 auto;
  overflow-y: scroll;
  img{
    width: 200px;
    height: 80px;
  }

  color: #88D8CB;
  font-size: 14px;
}
  .positionInfo {
    width: calc(100% - 20px);
    height: 2.8rem;
    position: fixed;
    bottom: 10px;
    z-index: 999;
    background-color: #ffffff;
    border-radius: 15px;
    margin: 10px auto 0 auto;
    overflow-y: scroll;

    .history {
      padding: 6px 10px;

      .title {
        font-size: 16px;
        font-family: "苹方-简 中黑体";
        margin-bottom: 5px;
        font-weight: 500;
        color: #333333;
      }

      .detail {
        font-size: 14px;
        font-family: "苹方-简 常规体";
        margin-bottom: 10px;
        white-space: normal;
        word-break: break-all;
        overflow: hidden;
        font-weight: 400;
        color: #222222;
      }
    }
  }
}
</style>
